import { render, staticRenderFns } from "./AdministrationUsersContentMenu.vue?vue&type=template&id=ffb2338e&scoped=true"
import script from "./AdministrationUsersContentMenu.vue?vue&type=script&lang=ts"
export * from "./AdministrationUsersContentMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb2338e",
  null
  
)

export default component.exports